import { Modal } from 'antd';

import DocumentViewer from '@common/components/DocumentViewer/DocumentViewer';

import './TermsAndConditionsModal.scss';

interface TermsAndConditionsModalProps {
    title: string;
    documentURL: string;
    visible: boolean;
    onCancel: () => void;
}

const TermsAndConditionsModal = ({
    title,
    documentURL,
    visible,
    onCancel,
}: TermsAndConditionsModalProps): JSX.Element => (
    <Modal
        open={visible}
        onCancel={onCancel}
        centered
        footer={null}
        title={title}
        closable
        className="TermsAndConditionsModal"
    >
        <div className="TermsAndConditionsModal__content TermsAndConditionsModal__content--wide">
            <DocumentViewer url={documentURL} />
            <a href={documentURL} className="TermsAndConditionsModal__link" target="_blank" rel="noopener noreferrer">
                Print this document
            </a>
        </div>
    </Modal>
);

export default TermsAndConditionsModal;
